import React, { useEffect, useRef, useState } from "react";
import ProductCart from "./ProductCart";
import { CustomerSearchBar } from "./CustomerSearchBar";
import { useTotalAmount } from "../TotalAmountContext";
import { useItemCount } from "../ItemCountContext";
import PaymentModal from "../../Modal/Payment_Modal";
import FreeOfferModal from "../sessioncomponents/FreeOfferModal" // adjust path

import {
  cash_in_session,
  cash_out_session,
  clear_cart_icon,
  customers_icon,
  quick_settle,
  return_icon,
} from "../../../assets";
import AddCustomer_Modal from "../../Modal/AddCustomer_Modal";
import { useSelector } from "react-redux";
import axiosInstance from "../../../AxiosInstance";
import { URLS } from "../../../API/API endpoints";
import { useNavigate } from "react-router-dom"; // Updated import for navigation
import {
  addProducts,
  clearProducts,
} from "../../../Redux/Action/productsAction";
import { useDispatch } from "react-redux";
import {
  clearCustomer,
  setCustomer,
} from "../../../Redux/Action/getcustomerAction";
import i18next, { t } from "i18next";
import { useTranslation } from "react-i18next";
import CashIn_Modal from "../../Modal/CashIn_Modal";
import { clearReturnProducts } from "../../../Redux/Action/returnproductAction";
import { toast } from "react-toastify";
import { setForRefund } from "../../../Redux/Action/refundAction";
import SessionLogout from "../../Modal/SessionLogout_Modal";
import { clearPaymentMethod } from "../../../Redux/Action/paymentAction";
import SubscriptionExpired from "../../Modal/SubscriptionExpired";
import dayjs from "dayjs";
import { detectWebDeviceType, isTablet } from "../../../utils";
import { logButtonClick } from "../../../API/API Functions/ProductRequest_API";
import {
  setClosePaymentModal,
  setOpenPaymentModal,
} from "../../../Redux/Action/paymentModalOpenAction";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { clearBillDiscount, setBillDiscountAction } from "../../../Redux/Action/billDiscountAction";

dayjs.extend(utc);
dayjs.extend(timezone);

const SESSION_STORAGE_KEY = "products";
const LoadingSpinner = () => {
  return (
    <div
      style={{ zIndex: 50 }}
      className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50"
    >
      <div className="spinner">
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
      </div>
    </div>
  );
};

function CustomerButton({ openAddCustomerModal, disabled }) {
  return (
    <div
      onClick={disabled ? undefined : openAddCustomerModal}
      // className={`flex flex-col justify-centerr w-[190px] items-center py-1.5 whitespace-nowrap rounded-xl shadow-sm bg-gradient-to-b from-yellow-200 via-yellow-400 to-yellow-400 text-white max-md:px-5 ${
      //   disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
      // }`}
      className={`flex flex-col justify-centerr w-[190px] items-center py-1.5 whitespace-nowrap rounded-xl shadow-sm bg-[#FABF01] text-white max-md:px-5 ${disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
        }`}
    >
      <img
        src={customers_icon}
        alt="customers_icon"
        className="self-center w-7 aspect-square"
      />
      <div>{t("Customers")}</div>
    </div>
    // <div
    //   className="flex flex-col justify-centerr w-[190px] items-center py-1.5 whitespace-nowrap rounded-xl shadow-sm bg-gradient-to-b from-yellow-200 via-yellow-400 to-yellow-400 text-white max-md:px-5 cursor-pointer"
    //   onClick={openAddCustomerModal}
    // >
    //   <img
    //     src={customers_icon}
    //     alt="customers_icon"
    //     className="self-center w-7 aspect-square"
    //   />
    //   <div>{t("Customers")}</div>
    // </div>
  );
}

// function ReturnButton() {
//   return (
//     <div className="flex flex-col justify-center px-12 py-1.5 whitespace-nowrap rounded-xl shadow-sm bg-gradient-to-b from-red-200 via-red-500 to-red-500 text-white max-md:px-5">
//       <img
//         src={return_icon}
//         alt="return_icon"
//         className="self-center w-7 aspect-square"
//       />
//       <div>Return</div>
//     </div>
//   );
// }

function CashInButton({ openCashInModal }) {
  const deviceType = detectWebDeviceType();

  return (
    <button
      onClick={openCashInModal}
      // className="flex flex-col justify-centerr w-[190px] items-center  py-1.5 rounded-xl shadow-sm bg-gradient-to-b from-lime-200 via-lime-500 to-lime-600 text-white max-md:px-5"
      className={`flex flex-col justify-center items-center px-5 h-16 py-1.5 rounded-xl shadow-sm bg-[#7EC242] text-white max-md:px-5 ${deviceType === "tablet" ? "w-full" : "w-[190px]"
        }`}
    >
      <img
        src={cash_in_session}
        alt="cash_in_session"
        className="self-center w-7 aspect-square"
      />
      <div>{t("Cash IN")}</div>
    </button>
  );
}

function CashOutButton({ openCashOutModal }) {
  const deviceType = detectWebDeviceType();

  return (
    <div
      onClick={openCashOutModal}
      // className="flex flex-col justify-center w-[190px] cursor-pointer items-center py-1.5 rounded-xl shadow-sm bg-gradient-to-b from-blue-200 via-blue-500 to-blue-500 text-white max-md:px-5"
      className={`flex flex-col justify-center cursor-pointer items-center py-1.5 px-5 h-16 rounded-xl shadow-sm bg-[#1b4597] text-white max-md:px-5 ${deviceType === "tablet" ? "w-full" : "w-[190px]"
        }`}
    >
      <img
        src={cash_out_session}
        alt="cash_out_session"
        className="self-center w-7 aspect-square"
      />
      <div>{t("Cash OUT")}</div>
    </div>
  );
}

function QuickSettleButton({ onClick, totalQuantity }) {
  // console.log("TOTAL Q", totalQuantity);
  const deviceType = detectWebDeviceType();

  return (
    <div
      onClick={totalQuantity > 0 ? onClick : undefined}
      className={`flex flex-col justify-center cursor-pointer px-5 h-16 whitespace-nowrap items-center py-1.5 rounded-xl shadow-sm bg-[#1b4597] text-white max-md:px-5
    ${deviceType === "tablet" ? "w-full" : "w-[190px]"}
    ${totalQuantity <= 0 ? "opacity-60 cursor-not-allowed" : ""}
  `}
    // className={`flex flex-col justify-center w-[190px] cursor-pointer whitespace-nowrap items-center py-1.5 rounded-xl shadow-sm bg-[#1b4597] text-white max-md:px-5 ${
    //   totalQuantity <= 0 && "opacity-60 cursor-not-allowed"
    // }`}
    >
      <img
        src={quick_settle}
        alt="quick_settle"
        className="self-center w-7 aspect-square"
      />
      <div>{t("Quick Checkout")}</div>
    </div>
  );
}

const ReturnButton = () => {
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setForRefund(true));
    navigate(`/orders?refundorder`);
    // navigate(`/orders?refundorder`);
  };
  return (
    <div
      onClick={handleClick}
      className={`flex flex-col justify-center cursor-pointer px-5 h-16 whitespace-nowrap items-center py-1.5 rounded-xl shadow-sm bg-[#F42020] text-white max-md:px-5 ${deviceType === "tablet" ? "w-full" : "w-[190px]"
        }`}
    >
      <img
        src={return_icon}
        alt="return_icon"
        className="self-center w-7 aspect-square"
      />
      <div>{t("Return")}</div>
    </div>
  );
};

// const ReturnButton = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const handleClick = () => {
//     dispatch(setForRefund(true));
//     navigate(`/orders?refundorder`);
//     // navigate(`/orders?refundorder`);
//   };
//   return (
//     <div
//       onClick={handleClick}
//       className="flex justify-center w-[21vh] py-2 font-semibold bg-gradient-to-b from-red-400 via-red-500 to-red-500 text-white whitespace-nowrap rounded-lg cursor-pointer"
//     >
//       <img
//         src={return_icon}
//         alt="return_icon"
//         className="shrink-0 self-start w-6 aspect-[0.96]"
//       />
//       <div className="mt-0.5 ml-1">{t("Return")}</div>
//     </div>
//   );
// };

const SessionFooter = ({
  setModals,
  localProducts,
  setSelectedIndex,
  totalBillAmount,
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const deviceType = detectWebDeviceType();

  const [partnerId, setPartnerId] = useState("");
  const { totalAmount } = useTotalAmount();
  const { itemCount } = useItemCount();
  const [paymentMethod, setPaymentMethod] = useState();
  const { user } = useSelector((state) => state?.login);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isAddCustomerModalOpen, setIsAddCustomerModalOpen] = useState(false);
  const [isAddCustomerModalOpen2, setIsAddCustomerModalOpen2] = useState(false);
  const [isSessionLogout, setIsSessionLogout] = useState(false);
  const [isSubscription, setIsSubscription] = useState(false);

  const [tenderCash, setTenderCash] = useState(0);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState();
  const Change = tenderCash - total;
  const navigate = useNavigate(); // Using useNavigate hook for navigation
  // console.log("tenderCash==>",tenderCash)
  const { selectedCustomer } = useSelector((state) => state.getcustomer);
  const [isCashInModalOpen, setIsCashInModalOpen] = useState(false);
  const [isCashOutModalOpen, setIsCashOutModalOpen] = useState(false);
  const returnProducts = localProducts.filter((product) => product.isReturn);
  const newProducts = localProducts.filter((product) => !product.isReturn);
  const [isApiInProgress, setIsApiInProgress] = useState(false);
  const [deliveryCheck, setDeliveryCheck] = useState(false);
  const [deliveryFee, setDeliveryFee] = useState(0); // State for delivery fee
  const [returnDeliveryFee, setReturnDeliveryFee] = useState(0); // State for delivery fee
  const [constReturnDeliveryFee, setConstReturnDeliveryFee] = useState(0);
  const [showReturnDelivery, setShowReturnDelivery] = useState(false);
  const [isDeliveryFeeSet, setIsDeliveryFeeSet] = useState(false);
  const [isCompanyCheckout, setCompanyCheckout] = useState(false);

  const [discountType, setDiscountType] = useState("value"); // "Percentage" | "Amount"
  const [discountValue, setDiscountValue] = useState("");
  const [bilOffers, setBillOffers] = useState([]);



  const negativeSale = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_allow_negative_sale,
  );
  const [totalBill, setTotalBill] = useState(0);

  let finalDiscount = 0;
  const isETAenabled = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_eta_enabled,
  );
  if (discountType === "value") {
    finalDiscount = discountValue; // e.g., ₹10 off
  } else if (discountType === "percentage") {
    finalDiscount = (totalAmount * discountValue) / 100; // e.g., 10% of total
  }

  const grandTotal =
    Number(deliveryFee) + totalAmount - returnDeliveryFee - finalDiscount;
  const originalTotal = Number(deliveryFee) + totalAmount - returnDeliveryFee;
  const nonReturnTotal = newProducts.reduce(
    (total, item) => {
      if (item?.is_offer || item?.offer || item?.isFreeProduct) {
        return total;
      }
      const qty = Number(item.quantity) || 0;
      const price = Number(item.price_after_discount) || 0;
      const itemTotal = qty * price;

      console.log("item:", item);

      return total + itemTotal;

    },
    0
  );


  const totalCostPrice = localProducts
    ?.filter((item) => ((item.uom == "KG" || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) > 0)
    .reduce((sum, item) => {
      const qty = item.pack_id ? item.pack_qty * ((item.uom == "KG" || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) : (item.uom == 'KG' && item.is_selling_gram ? item.quantity / 1000 : item.quantity);

      const cost = Number(item.cost_price || 0) * qty;

      return sum + cost;
    }, 0);

  const [orderFromOptions, setOrderFromOptions] = useState([]);

  const totalRefundValue = returnProducts.reduce((accumulator, product) => {
    console.log("product.is_offer", product.is_offer);
    if (product.is_offer) return accumulator; // Skip offer products in refund calculation
    return accumulator + product.price * product.qty;
  }, 0);

  const openCashInModal = () => setIsCashInModalOpen(true);
  const closeCashInModal = () => setIsCashInModalOpen(false);

  const openCashOutModal = () => setIsCashOutModalOpen(true);
  const closeCashOutModal = () => setIsCashOutModalOpen(false);
  const isProcessingRef = useRef(false);

  const openPaymentModal = () => {
    setIsPaymentModalOpen(true);
    dispatch(setOpenPaymentModal());
  };

  // const closePaymentModal = () => setIsPaymentModalOpen(false); setDeliveryCheck(true);
  const openAddCustomerModal = () => setIsAddCustomerModalOpen(true);
  const closeSubscriptionModal = () => setIsSubscription(false);


  const closePaymentModal = () => {
    setIsPaymentModalOpen(false);
    setDeliveryCheck(false);
    const maxDisc = Number(maxDiscount) || 0;
    console.log("MAX DISCOUNT", maxDisc)
    const appliedDiscount = maxDisc > 0 ? Math.min(billDiscount, maxDisc) : 0;
    if (appliedDiscount > 0) {
      setDiscountType("value");
      setDiscountValue(String(appliedDiscount));
    } else {
      setDiscountType("");
      setDiscountValue("");
    }
  };
  const openSessionLogout = () => setIsSessionLogout(true);

  const userData = useSelector((state) => state?.login?.user?.result);
  const refundRecieptNo = useSelector(
    (state) => state.orderlinesReducer?.orderLines[0]?.receipt_no,
  );
  const getCustomerState = useSelector(
    (state) => state?.getcustomer?.selectedCustomer,
  );
  const [creditAmount, setCreditAmount] = useState("");

  const conformAddCustomerModal = (customer) => {
    if (customer?.partnerId) {
      dispatch(setCustomer(customer));
    }
    setIsAddCustomerModalOpen(false);
    setDeliveryCheck(false);
    setIsPaymentModalOpen(true);
  };

  const confirmAddCustomerModal = (customer, showSkipButton) => {
    if (customer?.partnerId) {
      dispatch(setCustomer(customer));
    }
    setDeliveryCheck(true);
    setIsAddCustomerModalOpen2(false);

    if (isCompanyCheckout && !isPaymentModalOpen) {
      setIsPaymentModalOpen(true);
    }
  };

  const handlePayButtonClick = () => {
    setCompanyCheckout(false);
    if (returnProducts.length > 0) {
      openPaymentModal();
      dispatch(setOpenPaymentModal());
    } else if (!selectedCustomer?.partnerId) {
      openAddCustomerModal();
      dispatch(setOpenPaymentModal());
    } else {
      openPaymentModal();
      dispatch(setOpenPaymentModal());
    }
  };

  const handleCompanyPayButtonClick = () => {
    setCompanyCheckout(true);
    if (returnProducts.length > 0) {
      openPaymentModal();
    } else if (!selectedCustomer?.partnerId) {
      setIsAddCustomerModalOpen2(true);
    } else {
      openPaymentModal();
    }
  };


  const getBillOffers = async () => {
    try {
      const payload = {
        company_id: userData?.company_id
      }

      const res = await axiosInstance.post(URLS.GET_CASHIER_BILL_OFFERS, payload)

      console.log("res1---->", res);
      setBillOffers(res?.data?.result?.data || []);
    }
    catch (err) {
      console.error(err)
    }
  }
  const BILL_OFFER_TYPE = "bill_free_item";
  const [showBillOfferModal, setShowBillOfferModal] = useState(false);
  const [billOfferChoices, setBillOfferChoices] = useState([]);
  const [selectedBillOffer, setSelectedBillOffer] = useState(null);

  // "Buy 900 get 1" -> 900. Fragile if name format changes — ask backend for an
  // explicit threshold field if one exists; otherwise this regex is a bit safer
  // than split(" ")[1] for names with commas ("Buy 1,000 get 2"):


  const [appliedBillDiscount, setAppliedBillDiscount] = useState(null);
  const [billDiscount, setBillDiscount] = useState(0);


  const lastAutoFillRef = useRef(null);
  const costPrice = parseFloat(String(totalCostPrice).replace(/[^0-9.]/g, "")) || 0;
  const maxDiscount = Math.max(nonReturnTotal - costPrice, 0);

  useEffect(() => {
    if (!bilOffers?.length) {
      dispatch(clearBillDiscount())

      setAppliedBillDiscount(null);
      setBillDiscount(0);
      return;
    }

    const eligibleOffers = bilOffers.filter((offer) => {
      return (
        offer.promo_offer_type === "bill_amount_off" &&
        offer.status === "active" &&
        totalAmount >= Number(offer.bill_amount)
      );
    });

    if (!eligibleOffers.length) {
      dispatch(clearBillDiscount())
      setAppliedBillDiscount(null);
      setBillDiscount(0);
      return;
    }

    const bestOffer = eligibleOffers.reduce((best, current) => {
      const bestValue =
        best.discount_type === "percentage"
          ? (totalAmount * best.discount_value) / 100
          : best.discount_value;

      const currentValue =
        current.discount_type === "percentage"
          ? (totalAmount * current.discount_value) / 100
          : current.discount_value;

      return currentValue > bestValue ? current : best;
    });

    console.log("Best Offer", bestOffer);

    let discount = 0;

    if (bestOffer.discount_type === "percentage") {
      discount = (totalAmount * Number(bestOffer.discount_value)) / 100;
    } else {
      const multiplier = bestOffer.repeat_for_multiple
        ? Math.floor(totalAmount / Number(bestOffer.bill_amount))
        : 1;

      discount = Number(bestOffer.discount_value) * multiplier;
    }
    dispatch(setBillDiscountAction(bestOffer, discount));

    setAppliedBillDiscount(bestOffer);
    setBillDiscount(discount);

  }, [totalAmount, bilOffers]);


  // Keep the order-level discount in sync with whichever bill-amount-off offer
  // is currently active. Runs whenever billDiscount changes (i.e. the cart
  // total crosses into/out of a different offer's threshold), including while
  // the payment modal is closed.
  useEffect(() => {
    const maxDisc = Number(maxDiscount) || 0;

    if (billDiscount <= 0) {
      if (
        lastAutoFillRef.current !== null &&
        discountType === "value" &&
        String(discountValue) === String(lastAutoFillRef.current)
      ) {
        setDiscountType("");
        setDiscountValue("");
      }
      lastAutoFillRef.current = null;
      return;
    }

    const appliedDiscount = maxDisc > 0 ? Math.min(billDiscount, maxDisc) : 0;
    const rounded = Math.round(appliedDiscount * 100) / 100;

    const isUntouched =
      discountValue === "" ||
      (discountType === "value" &&
        lastAutoFillRef.current !== null &&
        String(discountValue) === String(lastAutoFillRef.current));

    if (isUntouched) {
      setDiscountType("value");
      setDiscountValue(String(rounded));
    }
    // Always update this, whether or not we overwrote the field, so the next
    // change to billDiscount can still recognize "was this value ours?"
    lastAutoFillRef.current = rounded;
  }, [billDiscount, maxDiscount]);


  const payableAmount =
    totalAmount >= 0
      ? Math.max(0, totalAmount - billDiscount)
      : totalAmount;
  const getOfferThreshold = (offer) => {
    const match = offer?.name?.match(/[\d,]+/);
    return match ? Number(match[0].replace(/,/g, "")) : 0;
  };

  const handleBillOfferSelect = (offer) => {
    setSelectedBillOffer(offer);
    setShowBillOfferModal(false);

    syncBillOfferProducts([offer], totalAmount);
  };
  const evaluateBillOffers = (offers, cartTotal) => {
    if (!offers?.length) return [];
    const nowEgypt = dayjs()
      .tz("Africa/Cairo")
      .format("YYYY-MM-DD HH:mm:ss");
    console.log("Now Egypt", nowEgypt)
    return offers.filter((offer) => {
      if (offer.promo_offer_type !== BILL_OFFER_TYPE) {
        console.log(
          "Checking offer",
          offer.promotion_id
        );
        if (offer.promo_offer_type !== BILL_OFFER_TYPE) {
          console.log("Rejected: wrong type");
          return false;
        }

        return false;
      }
      if (offer.status !== "active") {
        if (offer.status !== "active") {
          console.log("Rejected: inactive");
          return false;
        }
        return false;
      }
      if (offer.start_date && nowEgypt < offer.start_date) {
        if (offer.start_date && nowEgypt < offer.start_date) {
          console.log("Rejected: before start");
          return false;
        }

        return false;
      }

      if (offer.end_date && nowEgypt > offer.end_date) {
        if (offer.end_date && nowEgypt > offer.end_date) {
          console.log("Rejected: expired");
          return false;
        }
        return false;
      }
      const threshold = offer?.bill_amount;
      console.log({
        cartTotal,
        threshold
      });

      if (!(threshold > 0 && cartTotal >= threshold)) {
        console.log("Rejected: threshold");
      }

      console.log("Evaluating", {
        cartTotal,
        offer: offer.name,
        promotion: offer.promotion_id,
        threshold: getOfferThreshold(offer),
        start: offer.start_date,
        end: offer.end_date,
        now: nowEgypt,
      });

      return threshold > 0 && cartTotal >= threshold;
    });
  };

  const getEarnedFreeQty = (offer, cartTotal, negativeSale) => {
    const threshold = getOfferThreshold(offer);
    if (!threshold) return 0;

    const multiples = offer.repeat_for_multiple
      ? Math.floor(cartTotal / threshold)
      : 1;

    let earnedQty = multiples * offer.free_qty;

    // Only cap by stock when negative sale isn't allowed —
    // mirrors the buy_available_qty check used for manual quantity increases.
    if (!negativeSale) {
      earnedQty = Math.min(earnedQty, offer.free_available_qty ?? earnedQty);
      if (earnedQty < 0) earnedQty = 0;
    }

    if (offer.max_free_per_order > 0) {
      earnedQty = Math.min(earnedQty, offer.max_free_per_order);
    }

    return earnedQty;
  };

  const buildFreeProductEntry = (offer, earnedQty) => ({
    prod_id: offer.free_product_id,
    promotion_id: offer.promotion_id,
    bill_offer_id: offer.promotion_id,
    name: offer.free_product_name,
    image_url: offer.free_product_image_url,
    barcode: offer.free_product_barcode,
    sale_price: offer.free_unit_price,
    cost_price: offer.free_cost_price,
    quantity: earnedQty,
    qty_available: offer.free_available_qty,
    isFreeProduct: true,
    is_offer: true,
    isReturn: false
  });

  const syncBillOfferProducts = (eligibleOffers, cartTotal) => {
    const eligibleIds = eligibleOffers.map((o) => o.promotion_id);

    // Only operate on the NEW-purchase side. Return-flagged items belong
    // to returnproductReducer and must never be written back through
    // addProducts (productsReducer) — doing so duplicates them once the
    // parent re-merges both slices into localProducts.
    const newSideProducts = localProducts.filter((p) => !p.isReturn);

    const withoutBillOffers = newSideProducts.filter(
      p => !(p.isFreeProduct && p.bill_offer_id)
    );

    const updated = [...withoutBillOffers];

    eligibleOffers.forEach((offer) => {
      const earnedQty = getEarnedFreeQty(offer, cartTotal, negativeSale);
      if (earnedQty <= 0) return;
      const idx = updated.findIndex(
        (p) => p.isFreeProduct && p.bill_offer_id === offer.promotion_id
      );
      if (idx !== -1) {
        if (updated[idx].quantity !== earnedQty) {
          updated[idx] = { ...updated[idx], quantity: earnedQty };
        }
      } else {
        updated.push(buildFreeProductEntry(offer, earnedQty));
      }
    });

    // Compare/dispatch against the new-side slice only, not the full
    // merged localProducts, so we never reintroduce return items here.
    if (JSON.stringify(updated) !== JSON.stringify(newSideProducts)) {
      dispatch(addProducts(updated));
    }
  };

  const prevSignatureRef = useRef([]); // array of "promotionId:multiples"

  useEffect(() => {
    if (!bilOffers?.length) return;

    const eligible = evaluateBillOffers(bilOffers, totalAmount);

    if (eligible.length === 0) {
      prevSignatureRef.current = [];
      setShowBillOfferModal(false);
      setBillOfferChoices([]);
      setSelectedBillOffer(null);
      syncBillOfferProducts([], totalAmount);
      return;
    }

    // compute multiples per offer up front — needed both for the
    // "did anything change" signature and for modalFreeQty
    const withMultiples = eligible.map((offer) => {
      const threshold = getOfferThreshold(offer);
      const multiples =
        offer.repeat_for_multiple && threshold
          ? Math.floor(totalAmount / threshold)
          : 1;

      let earnedQty = multiples * offer.free_qty;
      if (offer.max_free_per_order > 0) {
        earnedQty = Math.min(earnedQty, offer.max_free_per_order);
      }

      return { offer, multiples, earnedQty };
    });

    if (eligible.length === 1) {
      prevSignatureRef.current = withMultiples
        .map(({ offer, earnedQty }) => `${offer.promotion_id}:${earnedQty}`)
        .sort();
      syncBillOfferProducts([eligible[0]], totalAmount);
      return;
    }

    // signature = offer id + its current multiple, so crossing 1000 -> 2000
    // (same offers, but multiples 1 -> 2) counts as a real change
    const signature = withMultiples
      .map(({ offer, earnedQty }) => `${offer.promotion_id}:${earnedQty}`)
      .sort();


    const sameAsBefore =
      signature.length === prevSignatureRef.current.length &&
      signature.every((s, i) => s === prevSignatureRef.current[i]);

    if (sameAsBefore) {
      if (
        selectedBillOffer &&
        signature.some((s) => s.startsWith(`${selectedBillOffer.promotion_id}:`))
      ) {
        syncBillOfferProducts([selectedBillOffer], totalAmount);
      }
      return;
    }

    // Signature changed: either a different set of offers is eligible,
    // OR the same offers now grant a different quantity (multiplier bump).
    // Either way, the user needs to see the updated choices.
    prevSignatureRef.current = signature;

    const modalOffers = withMultiples.map(({ offer, earnedQty }) => ({
      ...offer,
      modalFreeQty: earnedQty, // already capped above, no need to recompute
    }));

    setBillOfferChoices(modalOffers);
    setSelectedBillOffer(null);
    setShowBillOfferModal(true);
  }, [totalAmount, bilOffers, negativeSale, selectedBillOffer]);



  useEffect(() => {
    getBillOffers();
  }, [])

  console.log(bilOffers)

  useEffect(() => {
    //  setModals(isPaymentModalOpen || isAddCustomerModalOpen ? true : false)
    setModals(isPaymentModalOpen || isAddCustomerModalOpen ? true : false);
    getOrderFrom();
    if (getCustomerState && isPaymentModalOpen) {
      getCreditAomunt();
    }

    if (!isPaymentModalOpen) {
      setCreditAmount("");
    }

    if (order_id && isPaymentModalOpen) {
      getRefundDeliveryFee();
    }

    if (!isPaymentModalOpen) {
      setIsDeliveryFeeSet(false);
      setShowReturnDelivery(false);
      setReturnDeliveryFee(0);
    }
  }, [isPaymentModalOpen, isAddCustomerModalOpen, getCustomerState]);

  useEffect(() => {
    const total = localProducts?.reduce((sum, product) => {
      console.log("product.isFreeProduct", product.isFreeProduct);
      if (product?.isFreeProduct) {
        return sum; // Skip free products in total calculation
      }
      return sum + product.sale_price * ((product.uom == "KG" || product.uom == "كجم") && product.is_selling_gram ? product.quantity / 1000 : product.quantity);
    }, 0);
    setTotal(total);
  }, [localProducts]);

  const getPaymentMethod = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.PAYMENT_METHODS, {
        user_id: user?.result?.user_id,
      });
      // console.log("getPaymentMethod--> ", response?.data?.result?.data);
      if (response?.data.result.data != null) {
        handleQuickSettle(response?.data?.result?.data[0]);
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const getRefundDeliveryFee = async () => {
    if (isDeliveryFeeSet) return;
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.GET_REFUND_DELIVERY_FEE, {
        order_id: order_id,
      });
      // console.log(
      //   "getRefundDeliveryFee--> ",
      //   response?.data?.result?.return_delivery_fee
      // );
      if (
        response?.data?.result?.status === "No Any Refund Order's" &&
        response?.data?.result?.return_delivery_fee > 0
      ) {
        setReturnDeliveryFee(response?.data?.result?.return_delivery_fee);
        setConstReturnDeliveryFee(response?.data?.result?.return_delivery_fee);
        setShowReturnDelivery(true);
        setIsDeliveryFeeSet(true);
        setLoading(false);
      } else {
        setReturnDeliveryFee(0);
        setShowReturnDelivery(false);
        setLoading(false);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  // console.log("localProducts", localProducts);


  const handleQuickSettle = async (paymentMode) => {
    if (returnProducts?.length > 0) {
      refundOrderValidate(true, paymentMode);
    } else {
      if (totalQuantity <= 0) {
        return;
      }

      let totalProductDiscount = 0;
      let totalTaxAmount = 0;
      let totalTaxAmountInclusive = 0;

      try {
        setLoading(true);

        const lines = localProducts
          ?.filter((item) => ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) > 0)
          .map((item) => {
            console.log("Item:", item);

            let discountType = "";
            let discountAmount = 0;
            let discountPer = 0;
            const taxRate = Number(item?.vat_details?.tax_rate_percent || 0);
            const isInclusive =
              item?.vat_details?.is_tax_price_inclusive === true;
            // PRODUCT-LEVEL DISCOUNT
            if (item.discount_type && item.discount_type !== "") {
              if (item.discount_type === "percentage") {
                discountType = "percentage";
                discountPer = Number(item.discount_value || 0);
                let salePriceWithTax =
                  isETAenabled &&
                    item?.vat_details?.tax_id &&
                    taxRate > 0 &&
                    !isInclusive
                    ? item.sale_price * (taxRate / 100) + item.sale_price
                    : item.sale_price;
                discountAmount =
                  (salePriceWithTax * (item.is_selling_gram ? item.quantity / 1000 : item.quantity) * discountPer) / 100;
              } else if (item.discount_type === "value") {
                discountType = "value";
                discountAmount =
                  Number(item.discount_value || 0) *
                  Number(item.pack_id ? (item.quantity) : (item.quantity));
              }
            }

            totalProductDiscount += discountAmount;

            const qty = item.pack_id
              ? item.pack_qty * ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity)
              : ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity);

            const subtotal =
              item.sale_price * (item?.pack_id ? ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) : qty);
            // ---------------- PRICE UNIT FIX FOR INCLUSIVE TAX ----------------
            let priceUnit = item.sale_price;

            if (
              isETAenabled &&
              item?.vat_details?.is_tax_price_inclusive === true &&
              Number(item?.vat_details?.tax_rate_percent) > 0
            ) {
              const rate = Number(item.vat_details.tax_rate_percent);
              priceUnit = item.sale_price / (1 + rate / 100);
            }
            // ------------------------------------------------------------------

            // ---------------- TAX CALCULATION ----------------
            let taxAmount = 0;
            let subtotalIncl = subtotal - discountAmount;

            if (isETAenabled && item?.vat_details?.tax_id && taxRate > 0) {
              if (!isInclusive) {
                taxAmount = subtotal * (taxRate / 100);
                subtotalIncl = subtotalIncl + taxAmount;
                totalTaxAmount += taxAmount;
              } else {
                totalTaxAmountInclusive += (item?.sale_price - priceUnit) * (item?.pack_id ? ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) : qty);;
              }
            }
            // ---------------------------------------------------------
            if (item.isFreeProduct || (item.offer_id && item.promo_offer_type === 'bill_free_item')) {
              subtotalIncl = 0;
              taxAmount = 0;
            }
            return [
              0,
              0,
              {
                name: user?.result?.session_name,
                product_id: item?.hamper_id ? false : item.prod_id,
                hamper_id: item?.hamper_id ? item?.hamper_id : false,
                full_product_name: item.name,
                qty: qty,
                price_unit: Number(priceUnit),

                price_subtotal: subtotalIncl,
                price_subtotal_incl: subtotalIncl,

                ...(isETAenabled && { tax_id: item?.vat_details?.tax_id }),
                ...(isETAenabled && { tax_rate_percent: taxRate }),
                ...(isETAenabled && {
                  tax_amount: isInclusive
                    ? (item.sale_price - priceUnit) * (item?.pack_id ? ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) : qty)
                    : taxAmount,
                }),
                ...(isETAenabled && { is_tax_price_inclusive: isInclusive }),

                tax_ids: [[6, false, []]],
                package_id: item?.pack_id,
                ...(item?.pack_qty && { pack_qty: ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) }),

                discount_type:
                  discountAmount == 0 && discountPer == 0
                    ? false
                    : (discountType == 'value' ? "Amount" : discountType == 'percentage' ? 'Amount' : ''),
                discount_amount: discountAmount,
                discount_per: discountPer,

                // offer_id only on the line when the free product came from a buy_x_get_y promo
                ...(item?.isFreeProduct && {
                  offer_id: item?.promotion_id || false,
                }),
              },
            ];
          });



        let partner = 0;
        let date = new Date();

        const padToTwoDigits = (num) => num.toString().padStart(2, "0");
        const year = date.getFullYear();
        const month = padToTwoDigits(date.getMonth() + 1);
        const day = padToTwoDigits(date.getDate());
        const hours = padToTwoDigits(date.getHours());
        const minutes = padToTwoDigits(date.getMinutes());

        let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
        let payment_id;
        let totalAmount;

        const cashMethod = paymentMethod?.find((item) => item.name === "Cash");

        let payment_type;

        if (paymentMode?.name === "Cash") {
          payment_type = "cash";
        } else if (paymentMode?.name === "Bank" || paymentMode?.bank_id) {
          payment_type = "bank";
        } else if (paymentMode?.name === "COD") {
          payment_type = "COD";
        } else if (paymentMode?.name === "Cash & Bank") {
          payment_type = "cash_bank";
        } else {
          payment_type = "";
        }

        payment_id = paymentMode.id;

        totalAmount = total;

        const totalAfterProductDiscount = total - totalProductDiscount;

        let OrderdiscountType = "";
        let OrderdiscountAmount = 0;
        let OrderdiscountPer = 0;

        if (discountType && discountType !== "") {
          if (discountType === "percentage") {
            OrderdiscountType = "percentage";
            OrderdiscountPer = Number(discountValue || 0);
            OrderdiscountAmount =
              (totalAfterProductDiscount * OrderdiscountPer) / 100;
          } else if (discountType === "value") {
            OrderdiscountType = "value";
            OrderdiscountAmount = Math.min(
              Number(discountValue || 0),
              totalAfterProductDiscount,
            );
          }
        }

        const totalDiscount = totalProductDiscount + OrderdiscountAmount;
        const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

        const netTotal = round2(
          totalAfterProductDiscount -
          OrderdiscountAmount -
          (isETAenabled ? totalTaxAmount : 0)
        );

        const statementAmount = netTotal;

        let payloads = {
          lang: i18next.language === "ar" ? "ar_001" : "en_US",
          is_app_order: false,
          is_credit_order: paymentMode?.name === "Credit" ? true : false,
          data: {
            pos_session_id: user?.result?.session_id,
            user_id: user?.result?.user_id,
            state: "paid",
            payment_type: payment_type,

            // false when the free line is buy_x_get_y — that offer_id lives on the line instead
            offer_id:
              localProducts.find(
                (p) => p?.isFreeProduct && p?.promo_offer_type !== "buy_x_get_y"
              )?.promotion_id || false,

            discount_type: OrderdiscountType == 'value' ? "Amount" : OrderdiscountType == 'percentage' ? 'Amount' : '',
            discount_amount: OrderdiscountAmount,
            discount_per: OrderdiscountPer,
            total_discount: totalDiscount,

            amount_paid: netTotal,
            amount_total: netTotal,
            ...(isETAenabled && {
              total_tax_amount: Number(
                (totalTaxAmount + totalTaxAmountInclusive).toFixed(2),
              ),
            }),

            amount_tax: 0,
            amount_return: tenderCash ? tenderCash - netTotal : 0,

            lines: lines,
            to_invoice: false,
            sequence_number: "",
            to_ship: false,
            is_tipped: false,
            tip_amount: 0,
            partner_id: partner && partner != "" ? partner : 0,
            creation_date: formattedDate,
            order_from_id: false,
            fiscal_position_id: "",
            pricelist_id: 1,
            delivery_fee: 0,

            statement_ids: [
              [
                0,
                0,
                {
                  name: formattedDate,
                  payment_method_id: JSON.parse(payment_id),
                  amount: statementAmount,
                  payment_status: "",
                  ...(paymentMode?.bank_id && { bank_id: paymentMode?.bank_id }),
                  ticket: "",
                  card_type: "",
                  cardholder_name: "",
                  transaction_id: "",
                },
              ],
            ],
          },
        };

        const response = await axiosInstance.post(
          URLS.CREATE_ORDER_NEW,
          payloads,
        );
        if (response?.data.result.status === "Successfully") {
          const order_id = response?.data?.result?.order_id;
          navigate(`/OrderCheckout?order_id=${order_id}`);
          dispatch(clearPaymentMethod());
        } else if (
          response?.data.result.status === "Session not in opened state."
        ) {
          setIsSessionLogout(true);
        } else if (
          response?.data.result.status_code === 400 &&
          response?.data.result.status ===
          "Subscription is Expired...Please Renew."
        ) {
          setIsSubscription(true);
        }
      } catch (err) {
      } finally {
        setLoading(false);
        isProcessingRef.current = false;
      }
    }
  };

  const order_id = returnProducts?.[0]?.order_id;
  // console.log("returnProducts===>", returnProducts);

  const isCreditOrder = useSelector((state) => {
    const orders = state.orders?.orders || [];
    const matchingOrder = orders.find((order) => order.id === order_id);
    return matchingOrder?.is_credit_order ?? false;
  });

  console.log("returnProducts===>", returnProducts);
  // console.log("newProducts===>", newProducts);

  const refundOrderValidate = async (
    isQuick,
    paymentMode,
    partnerId,
    orderFrom,
    selectedSalesman,
    selectedDeliveryBoys
  ) => {
    let Customer_partner_id = partnerId; // Default to 0

    if (selectedCustomer) {
      try {
        const CustomerResponse = await axiosInstance.post(
          URLS.GET_CUSTOMER_DETAILS,
          { user_id: user?.result?.user_id, mobile: selectedCustomer },
        );

        if (CustomerResponse?.data?.result?.status) {
          Customer_partner_id =
            CustomerResponse.data.result.partners_details.id;
        }
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    }

    let payment_type;

    // Determine payment type based on payment mode
    if (paymentMode?.name === "Cash") {
      payment_type = "cash";
    } else if (paymentMode?.name === "Bank" || paymentMode?.bank_id) {
      payment_type = "bank";
    } else if (paymentMode?.name === "COD") {
      // payment_type = "COD";
      payment_type = "delivery";
    } else if (paymentMode?.name === "Cash & Bank") {
      payment_type = "cash_bank";
    } else if (paymentMode?.name === "Credit Card") {
      payment_type = "credit_card";
    } else if (paymentMode?.name === "InstaPay") {
      payment_type = "insta_pay";
    } else if (paymentMode?.name === "ValU") {
      payment_type = "ValU";
    } else if (paymentMode?.name === "PayU") {
      payment_type = "PayU";
    } else if (paymentMode?.name === "Fawry") {
      payment_type = "Fawry";
    } else if (paymentMode?.name === "Vodafone Cash") {
      payment_type = "Vodafone_Cash";
    } else if (paymentMode?.name === "Prepaid") {
      payment_type = "Prepaid";
    } else {
      payment_type = ""; // Default case if none match
    }

    let totalProductDiscount = 0;
    let totalTaxAmount = 0; // ✅ ADDED
    let totalTaxAmountInclusive = 0; // ✅ ADDED

    const new_lines = newProducts?.map((product) => {
      const qty = product?.pack_id
        ? product?.pack_qty * ((product.uom == 'KG' || product.uom == "كجم") && product.is_selling_gram ? product.quantity / 1000 : product.quantity)
        : ((product.uom == 'KG' || product.uom == "كجم") && product.is_selling_gram ? product.quantity / 1000 : product.quantity);

      let discountType = "";
      let discountAmount = 0;
      let discountPer = 0;
      const taxRate = Number(product?.vat_details?.tax_rate_percent || 0);
      const isInclusive = product?.vat_details?.is_tax_price_inclusive === true;

      // PRODUCT-LEVEL DISCOUNT
      if (product.discount_type && product.discount_type !== "") {
        if (product.discount_type === "percentage") {
          discountType = "percentage";
          discountPer = Number(product.discount_value || 0);
          let salePriceWithTax =
            isETAenabled &&
              product?.vat_details?.tax_id &&
              taxRate > 0 &&
              !isInclusive
              ? (product.sale_price * (taxRate / 100)) + product.sale_price
              : product.sale_price;
          discountAmount = (salePriceWithTax * (product.quantity) * discountPer) / 100;
        } else if (product.discount_type === "value") {
          discountType = "value";
          discountAmount = Number(product.discount_value || 0) * Number(product.pack_id ? (product.quantity) : ((product.uom == 'KG' || product.uom == "كجم") && product.is_selling_gram ? product.quantity / 1000 : product.quantity));
        }
      }
      if (!product.isFreeProduct) {
        totalProductDiscount += discountAmount;
      }

      // totalProductDiscount += discountAmount;

      const priceSubtotal = product.sale_price * (product?.pack_id ? ((product.uom == 'KG' || product.uom == "كجم") && product.is_selling_gram ? product.quantity / 1000 : product.quantity) : qty);
      let priceUnit = product?.sale_price;

      if (
        isETAenabled &&
        product?.vat_details?.is_tax_price_inclusive === true &&
        Number(product?.vat_details?.tax_rate_percent) > 0
      ) {
        const rate = Number(product?.vat_details.tax_rate_percent);
        priceUnit = product?.sale_price / (1 + rate / 100);
      }
      // ------------------------------------------------------------------

      // ---------------- TAX CALCULATION (ADDED) ----------------

      let taxAmount = 0;
      let subtotalIncl = priceSubtotal - discountAmount;

      if (isETAenabled && product?.vat_details?.tax_id && taxRate > 0) {
        if (!isInclusive) {
          taxAmount = priceSubtotal * (taxRate / 100);
          subtotalIncl = subtotalIncl + taxAmount;
          totalTaxAmount += taxAmount;
        } else {
          totalTaxAmountInclusive += (product.sale_price - priceUnit) * (product?.pack_id ? ((product.uom == 'KG' || product.uom == "كجم") && product.is_selling_gram ? product.quantity / 1000 : product.quantity) : qty);
        }
      }

      if (product.isFreeProduct) {
        subtotalIncl = 0;
        taxAmount = 0;
      }

      return {
        product_id: product?.hamper_id ? false : product.prod_id,
        hamper_id: product?.hamper_id ? product?.hamper_id : false,
        price_unit: isETAenabled ? Number(priceUnit) : product?.sale_price,
        qty,
        package_id: product?.pack_id,
        ...(product?.pack_qty && { pack_qty: ((product.uom == 'KG' || product.uom == "كجم") && product.is_selling_gram ? product.quantity / 1000 : product.quantity) }),

        price_subtotal: subtotalIncl,
        price_subtotal_incl: subtotalIncl,
        ...(isETAenabled && { tax_id: product?.vat_details?.tax_id }),
        ...(isETAenabled && { tax_rate_percent: taxRate }),
        ...(isETAenabled && {
          tax_amount: isInclusive
            ? (product.sale_price - priceUnit) * (product?.pack_id ? ((product.uom == 'KG' || product.uom == "كجم") && product.is_selling_gram ? product.quantity / 1000 : product.quantity) : qty)
            : taxAmount,
        }),
        ...(isETAenabled && { is_tax_price_inclusive: isInclusive }),

        discount_type:
          discountAmount === 0 && discountPer === 0 ? false : (discountType == 'value' ? "Amount" : discountType == 'percentage' ? 'Amount' : ''),
        discount_amount: discountAmount,
        discount_per: discountPer,
      };
    });
    console.log("paymentModepaymentModepaymentModepaymentMode==>", paymentMode);
    // ---------------- ORDER DISCOUNT ----------------
    const totalAfterProductDiscount = total - totalProductDiscount;

    let OrderdiscountType = "";
    let OrderdiscountAmount = 0;
    let OrderdiscountPer = 0;

    if (discountType && discountType !== "") {
      if (discountType === "percentage") {
        OrderdiscountType = "percentage";
        OrderdiscountPer = Number(discountValue || 0);

        OrderdiscountAmount =
          (totalAfterProductDiscount * OrderdiscountPer) / 100;
      } else if (discountType === "value") {
        OrderdiscountType = "value";

        OrderdiscountAmount = Math.min(
          Number(discountValue || 0),
          totalAfterProductDiscount
        );
      }
    }

    // ----------- TOTAL DISCOUNT --------------
    const totalDiscount = totalProductDiscount + OrderdiscountAmount;
    const refundOrderPayload = {
      is_app_order: false,
      device_type: "Web",
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      order_id: parseInt(order_id),
      salesman_id: selectedSalesman?.value,
      delivery_boy_id:selectedDeliveryBoys?.value ?? false,
      partner_id: Customer_partner_id,
      payment_type: payment_type,
      return_delivery_fee: parseFloat(returnDeliveryFee),
      delivery_fee: parseFloat(deliveryFee),
      session_id: user?.result?.session_id,
      order_from_id: orderFrom ? orderFrom.id : false,
      ...(isETAenabled && {
        total_tax_amount: Number(
          (totalTaxAmount + totalTaxAmountInclusive).toFixed(2),
        ),
      }),
      // ✅ ONLY THIS OUTSIDE
      discount_type:
        OrderdiscountType === "value"
          ? "Amount"
          : OrderdiscountType === "percentage"
            ? "Amount"
            : "",

      discount_amount: OrderdiscountAmount,
      discount_per: OrderdiscountPer,

      total_discount: totalDiscount,



      lines: returnProducts.map((product) => {
        console.log(product)
        console.log("free product row:", returnProducts.find(p => p.isFreeProduct));

        const qty = product?.pack_id
          ? product?.pack_qty * ((product.uom == 'KG' || product.uom == "كجم") && product.is_selling_gram ? product.quantity / 1000 : product.quantity)
          : ((product.uom == 'KG' || product.uom == "كجم") && product.is_selling_gram ? product.quantity / 1000 : product.quantity);

        const priceUnit = product.sale_price;
        const lineSubtotal = product.isFreeProduct ? 0 : -(qty) * priceUnit;

        return {
          product_id: product?.hamper_id && product?.hamper_id != null ? false : product?.product_id || product?.id,
          qty,
          price_unit: priceUnit, // 👈 matches orderValidate's price_unit pattern
          ...(product?.pack_id && { package_id: product?.pack_id }),
          ...(product?.pack_qty && { pack_qty: product.quantity }),
          price_subtotal: lineSubtotal,
          price_subtotal_incl: lineSubtotal,
          discount_amount: product.isFreeProduct ? 0 : product.discount_amount,
          ...(product?.tax_id && { tax_id: product?.tax_id }),
          ...(product?.tax_id && { tax_rate_percent: product?.tax_rate_percent }),
          ...(product?.tax_id && {
            tax_amount: product.isFreeProduct ? 0 : product?.tax_amount,
          }),
          ...(product?.tax_id && {
            is_tax_price_inclusive: product?.is_tax_price_inclusive,
          }),
          ...(product?.hamper_id && { hamper_id: product?.hamper_id }),

          // 👇 matches orderValidate: only sent when the free product came from a buy_x_get_y promo
          ...(product?.isFreeProduct && { offer_id: product?.offer_id || product?.offer?.promotion_id || false }),
        };
      }),

      new_lines,
    };

    setLoading(true);
    try {
      console.log("selectedDeliveryBoys:", selectedDeliveryBoys);
console.log("delivery_boy_id:", selectedDeliveryBoys?.value);
      const response = await axiosInstance.post(
        URLS.REFUND_ORDER,
        refundOrderPayload,
      );

      if (
        response?.data?.result?.error ===
        "Return and purchase product(s) cannot be the same"
      ) {
        toast.error(
          t(
            "Cannot return and repurchase the same item. Please adjust your order.",
          ),
        );
        return;
      }

      if (
        response?.data?.result?.state ===
        "Subscription is Expired...Please Renew."
      ) {
        setIsSubscription(true);
        return;
      }

      // console.log("MMMM---->", response);

      if (response?.data.result) {
        const refundOrderId = response?.data?.result?.refund_order;
        // console.log("refundOrderId---->", refundOrderId);
        // console.log("paymentMode---->", paymentMode);

        let payment_id = paymentMode.id;
        let ReturnAmount = 0;

        // console.log("REREREREDD---->",refundOrderId);

        if (paymentMode.name !== "Cash") {
          ReturnAmount = 0; // Set to 0 for "Cash & Bank", "Delivery", and "Bank"
        } else {
          ReturnAmount = Number(tenderCash)
            ? Number(tenderCash) - grandTotal
            : 0; // Calculate for Cash and Credit
        }

        const paymentPayload = {
          is_credit_order:
            (paymentMode?.name === "Credit" ? true : false) || isCreditOrder,
          // is_credit_order: isCreditOrder,
          refund_order_id: refundOrderId,
          remark: "TEST",
          payments: [],
          amount_return: ReturnAmount,
          return_delivery_fee: parseFloat(returnDeliveryFee),
          lang: i18next.language === "ar" ? "ar_001" : "en_US",
        };

        // Prepare payment details based on payment mode
        if (paymentMode.name === "Cash") {
          if (payment_id?.cashId) {
            paymentPayload.payments.push(
              {
                payment_id: payment_id?.cashId,
                amount: Number(tenderCash),
              },
            );
          } else {
            paymentPayload.payments.push({
              payment_id: payment_id,
              amount: grandTotal + ReturnAmount,
            });
          }
        } else if (
          orderFrom?.name === "self_delivery" ||
          paymentMode.name === "COD"
        ) {
          if (payment_id?.cashId) {
            paymentPayload.payments.push(
              {
                payment_id: payment_id?.cashId,
                amount: Number(tenderCash),
              },
              {
                payment_id: payment_id?.bankId || payment_id?.methodId,
                amount: grandTotal - tenderCash,
              }
            );
          } else {
            paymentPayload.payments.push({
              payment_id: payment_id,
              amount: 0,
            });
          }
        } else if (
          paymentMode.name === "Bank" ||
          paymentMode.bank_id ||
          paymentMode.name === "Credit Card" ||
          paymentMode.name === "InstaPay" ||
          paymentMode?.name === "Fawry" ||
          paymentMode?.name === "Prepaid" ||
          paymentMode?.name === "PayU" ||
          paymentMode?.name === "Vodafone Cash" ||
          paymentMode?.name === "ValU"
        ) {
          if (payment_id?.cashId) {
            paymentPayload.payments.push(
              {
                payment_id: payment_id?.cashId,
                amount: Number(tenderCash),
              },
              {
                payment_id: payment_id?.bankId || payment_id?.methodId,
                amount: grandTotal - tenderCash,
              }
            );
          } else {
            paymentPayload.payments.push({
              payment_id: payment_id,
              ...(paymentMode.bank_id && { bank_id: paymentMode.bank_id }),
              amount: grandTotal,
            });
          }
        } else if (paymentMode.name === "Cash & Bank") {
          paymentPayload.payments.push(
            {
              payment_id: payment_id?.cashId,
              amount: Number(tenderCash),
            },
            {
              payment_id: payment_id?.bankId || payment_id?.methodId,
              amount: grandTotal - tenderCash,
            }
          );
        } else if (paymentMode.name === "Credit") {
          if (payment_id?.cashId) {
            paymentPayload.payments.push(
              {
                payment_id: payment_id?.cashId,
                amount: Number(tenderCash),
              },
              {
                payment_id: payment_id?.bankId || payment_id?.methodId,
                amount: grandTotal - tenderCash,
              }
            );
          } else {
            paymentPayload.payments.push({
              payment_id: payment_id,
              amount: totalAmount,
            });
          }
        }

        const paymentResponse = await axiosInstance.post(
          URLS.REFUND_ORDER_PAYMENT,
          paymentPayload,
        );

        if (paymentResponse?.data.result.state == "success") {
          const isNewOrder = newProducts?.length > 0;
          const idCreditOrder =
            (paymentMode?.name === "Credit" ? true : false) || isCreditOrder;
          // if (totalAmount < 0 && creditAmount?.response) {
          if (totalAmount < 0 && isCreditOrder) {
            CreditPayment();
            CashIn(false, idCreditOrder);
          } else if (
            totalAmount > 0 &&
            creditAmount?.response &&
            paymentMode?.name !== "Credit"
          ) {
            // CreditPayment();
            CashIn(isNewOrder, idCreditOrder);
          } else {
            RefundCreditPayment();
          }

          setLoading(false);
        }

        if (paymentResponse?.data.result.state === "success") {
          navigate(`/OrderCheckout?order_id=${refundOrderId}`);
          // logButtonClick(userData?.user_id, userData?.company_id, "Refund");
          dispatch(clearReturnProducts());
        } else {
          console.error("Error in refund order payment");
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      setIsApiInProgress(false);
    }
  };

  const getCreditAomunt = async () => {
    // console.log("getCustomerState----->", getCustomerState);
    let mobile = getCustomerState?.mobile || getCustomerState;

    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.GET_CUSTOMER_CREDIT, {
        phone: mobile,
      });

      // console.log("CREDIT RES--->", response);

      if (
        response?.data?.result[0].status_code === 200 &&
        response?.data?.result[0].status === "Customer Credits"
      ) {
        setCreditAmount(response?.data?.result[0]);
        // console.log("CREDIT Amount--->", creditAmount);
      }
    } catch (err) {
      console.error(err);
      // setErrorMessage("Failed to fetch credit amount.");
    } finally {
      setLoading(false);
    }
  };
  // console.log('returnTotal===>', totalRefundValue);
  // console.log('total===>', total);
  const CreditPayment = async (e) => {
    let amount_paid = 0;
    if (totalAmount > 0) {
      amount_paid = totalRefundValue || total;
    } else {
      amount_paid = total;
    }
    const payload = {
      pos_credit_id: creditAmount?.pos_credit_id,
      paid_amount: parseFloat(amount_paid),
      payment_date: dayjs().format("YYYY-MM-DD"),
      remark: `CASH DEBIT ${amount_paid} Against Order ${refundRecieptNo}`,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };

    try {
      const response = await axiosInstance.post(
        URLS.POS_CREDIT_PAYMENT,
        payload,
      );

      if (
        response.data?.result[0]?.status_code === 200 &&
        response.data?.result[0]?.status === "POS Credit Payment Done"
      ) {
        toast.success(t("Payment Submitted Successfully"));
      } else {
        console.error("Error submitting payment:", response.data);
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
    }
  };

  // console.log("PARTNER ID-->", selectedCustomer?.partnerID);

  const CashIn = (is_credit_refund, is_credit_order) => {
    const cashInPayload = {
      session_id: userData?.session_id,
      type: "cash_in",
      amount: totalAmount > 0 ? Math.abs(totalAmount) : -totalAmount,
      reason: "CREDIT IN",
      is_refund_with_new: is_credit_refund ? true : false,
      is_credit_order: is_credit_order ? true : false,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",

      // reason: `CREDIT IN - ${orderDetails?.customer_name} (${orderDetails?.mobile_no})`,
    };

    try {
      const cashInResponse = axiosInstance.post(
        URLS.CASH_IN_OUT,
        cashInPayload,
      );

      if (cashInResponse?.data?.status !== "Success") {
        console.error("Cash in failed:", cashInResponse?.data);
      }
    } catch (cashInErr) {
      console.error("Error in CASH_IN_OUT API:", cashInErr);
    }
  };

  const getOrderFrom = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.ORDER_FROM, {
        user_id: user?.result?.user_id,
        lang: i18next.language === "ar" ? "ar_001" : "en_US",
      });

      const posOrderFrom = response?.data?.result?.[0]?.pos_order_from;
      setOrderFromOptions(posOrderFrom);
      // }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const RefundCreditPayment = async (e) => {
    const creditPayload = {
      customer_id: creditAmount?.customer_id, // partner_id passed as customer_id
      credit_amount: totalAmount, // total amount passed as credit_amount
    };

    try {
      const response = await axiosInstance.post(URLS.ADD_CREDIT, creditPayload);

      if (
        response.data?.result[0]?.status_code === 200 &&
        response.data?.result[0]?.status === "POS Credit Payment Done"
      ) {
        toast.success(t("Payment Submitted Successfully"));
      } else {
        console.error("Error submitting payment:", response.data);
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
    }
  };

  const handleCheckout = (paymentMode, orderFrom, selectedSalesman,selectedDeliveryBoys) => {
    console.log('paymentMode==>', paymentMode);

    if (returnDeliveryFee > constReturnDeliveryFee) {
      toast.error(
        t(
          `The Return Delivery Fee cannot exceed EGP ${constReturnDeliveryFee}`,
        ),
      );
      return;
    }

    if (
      (orderFrom?.name === "self_delivery" ||
        paymentMode?.name === "COD" ||
        paymentMode?.name === "Credit") &&
      (!selectedCustomer?.partnerId ||
        (!selectedCustomer?.address_type_id &&
          selectedCustomer?.add_field_1 === "" &&
          selectedCustomer?.add_field_2 === "" &&
          selectedCustomer?.add_field_3 === ""))
    ) {
      setIsAddCustomerModalOpen2(true);
      // openAddCustomerModal()
      return;
    }
    if (isApiInProgress) return;
    setIsApiInProgress(true);
    if (returnProducts.length > 0) {
      refundOrderValidate(
        false,
        paymentMode,
        selectedCustomer?.partnerId,
        orderFrom,
        selectedSalesman,
        selectedDeliveryBoys
      );
    } else {
      orderValidate(
        "checkout",
        selectedCustomer?.partnerId,
        paymentMode,
        orderFrom,
        selectedSalesman,
        selectedDeliveryBoys

      );
    }
  };

  const orderValidate = async (value, partnerID, paymentMode, orderFrom, selectedSalesman,selectedDeliveryBoys) => {
    // console.log("paymentMode====>", paymentMode);
    let totalProductDiscount = 0;
    let totalTaxAmount = 0; // ✅ ADDED
    let totalTaxAmountInclusive = 0; // ✅ ADDED
    try {
      setLoading(true);

      console.log(localProducts)

      const lines = localProducts
        ?.filter((item) => ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) > 0)
        .map((item) => {
          let discountType = "";
          let discountAmount = 0;
          let discountPer = 0;
          console.log("ITEM", item)
          console.log(item?.promo_offer_type !== "buy_x_get_y");
          const taxRate = Number(item?.vat_details?.tax_rate_percent || 0);
          const isInclusive =
            item?.vat_details?.is_tax_price_inclusive === true;
          // PRODUCT-LEVEL DISCOUNT
          if (item.discount_type && item.discount_type !== "") {
            if (item.discount_type === "percentage") {
              discountType = "percentage";
              discountPer = Number(item.discount_value || 0);
              let salePriceWithTax =
                isETAenabled &&
                  item?.vat_details?.tax_id &&
                  taxRate > 0 &&
                  !isInclusive
                  ? (item.sale_price * (taxRate / 100)) + item.sale_price
                  : item.sale_price;
              console.log("salePriceWithTax==>", salePriceWithTax);

              discountAmount =
                (salePriceWithTax * (item.is_selling_gram ? item.quantity / 1000 : item.quantity) * discountPer) / 100;
            } else if (item.discount_type === "value") {
              discountType = "value";
              discountAmount =
                Number(item.discount_value || 0) *
                Number(item.pack_id ? (item.quantity) : (item.quantity));
            }
          }

          // // PRODUCT-LEVEL DISCOUNT
          // if (item.discount_type && item.discount_type !== "") {
          //   if (item.discount_type === "percentage") {
          //     discountType = "percentage";
          //     discountPer = Number(item.discount_value || 0);

          //     discountAmount =
          //       (item.sale_price *
          //         (item.pack_id ? item.quantity : item.quantity) *
          //         discountPer) /
          //       100;
          //   } else if (item.discount_type === "value") {
          //     discountType = "value";
          //     discountAmount =
          //       Number(item.discount_value || 0) *
          //       Number(item.pack_id ? item.quantity : item.quantity);
          //   }
          // }

          totalProductDiscount += discountAmount;

          const qty = item.pack_id
            ? item.pack_qty * ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity)
            : ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity);

          const subtotal =
            item.sale_price * (item?.pack_id ? ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) : qty);
          // ---------------- PRICE UNIT FIX FOR INCLUSIVE TAX ----------------
          let priceUnit = item.sale_price;

          if (
            isETAenabled &&
            item?.vat_details?.is_tax_price_inclusive === true &&
            Number(item?.vat_details?.tax_rate_percent) > 0
          ) {
            const rate = Number(item.vat_details.tax_rate_percent);
            priceUnit = item.sale_price / (1 + rate / 100);
          }
          // ------------------------------------------------------------------

          // ---------------- TAX CALCULATION (ADDED) ----------------

          let taxAmount = 0;
          let subtotalIncl = subtotal - discountAmount;

          if (isETAenabled && item?.vat_details?.tax_id && taxRate > 0) {
            if (!isInclusive) {
              taxAmount = subtotal * (taxRate / 100);
              subtotalIncl = subtotalIncl + taxAmount;
              totalTaxAmount += taxAmount;
            } else {
              totalTaxAmountInclusive += (item.sale_price - priceUnit) * (item?.pack_id ? ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) : qty);
            }
          }
          console.log("totalTaxAmountInclusive===>", totalTaxAmountInclusive);

          if (item.isFreeProduct || (item.offer_id && item.promo_offer_type === 'bill_free_item')) {
            subtotalIncl = 0;
            taxAmount = 0;
          }
          // ---------------------------------------------------------

          return [
            0,
            0,
            {
              name: user?.result?.session_name,
              product_id: item?.hamper_id ? false : item.prod_id,
              hamper_id: item?.hamper_id ? item?.hamper_id : false,
              full_product_name: item.name,
              qty: qty,
              price_unit: isETAenabled ? Number(priceUnit) : item?.sale_price,

              price_subtotal: subtotalIncl,
              price_subtotal_incl: subtotalIncl,

              ...(isETAenabled && { tax_id: item?.vat_details?.tax_id }),
              ...(isETAenabled && { tax_rate_percent: taxRate }),
              ...(isETAenabled && {
                tax_amount: isInclusive
                  ? (item.sale_price - priceUnit) * (item?.pack_id ? ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) : qty)
                  : taxAmount,
              }),
              ...(isETAenabled && { is_tax_price_inclusive: isInclusive }),

              tax_ids: [[6, false, []]],
              package_id: item?.pack_id,
              ...(item?.pack_qty && { pack_qty: ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity) }),

              discount_type:
                discountAmount == 0 && discountPer == 0 ? false : (discountType == 'value' ? "Amount" : discountType == 'percentage' ? 'Amount' : ''),
              discount_amount: discountAmount,
              discount_per: discountPer,

              // promotion_id / is_promo_line removed entirely.
              // offer_id is only sent on the line when the free product came from a buy_x_get_y promo.


              ...(item?.isFreeProduct &&
              {
                offer_id: item?.promotion_id || false,
              }),
            },
          ];
        });

      let partner = partnerID ? partnerID : partnerId;
      let date = new Date();

      const padToTwoDigits = (num) => num.toString().padStart(2, "0");
      const year = date.getFullYear();
      const month = padToTwoDigits(date.getMonth() + 1);
      const day = padToTwoDigits(date.getDate());
      const hours = padToTwoDigits(date.getHours());
      const minutes = padToTwoDigits(date.getMinutes());

      let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
      let payment_id;
      let totalAmount;
      const cashMethod = paymentMethod?.find((item) => item.name === "Cash");
      payment_id = paymentMode.id;

      let delivery_fee = parseFloat(deliveryFee); // Get the delivery fee from state

      const totalAfterProductDiscount = total - totalProductDiscount;

      // ---------------- ORDER DISCOUNT ----------------
      let OrderdiscountType = "";
      let OrderdiscountAmount = 0;
      let OrderdiscountPer = 0;

      if (discountType && discountType !== "") {
        if (discountType === "percentage") {
          OrderdiscountType = "percentage";
          OrderdiscountPer = Number(discountValue || 0);

          // FIX: apply on discounted total, not on full total
          OrderdiscountAmount =
            (totalAfterProductDiscount * OrderdiscountPer) / 100;
        } else if (discountType === "value") {
          OrderdiscountType = "value";

          // FIX: do not allow exceeding discounted total
          OrderdiscountAmount = Math.min(
            Number(discountValue || 0),
            totalAfterProductDiscount,
          );
        }
      }

      // ----------- TOTAL DISCOUNT --------------
      const totalDiscount = totalProductDiscount + OrderdiscountAmount;

      // ----------- FINAL NET TOTAL AMOUNT --------------
      const netTotal =
        totalAfterProductDiscount -
        OrderdiscountAmount +                    // ← added, matches handleQuickSettle + payableAmount
        (orderFrom?.name === "self_delivery" || paymentMode.name === "COD"
          ? (delivery_fee ? delivery_fee : 0)
          : 0) +
        (isETAenabled ? totalTaxAmount : 0);

      console.log("ORDRR DISCOUN AMOUNT", OrderdiscountAmount);

      if (orderFrom?.name === "self_delivery" || paymentMode.name === "COD") {
        payment_id = paymentMode.id; // Assuming paymentMode.id is the ID for Delivery
        totalAmount = 0; // Set amount to 0 for Delivery
        console.log("SELF DLEEIEEEE--->", totalAmount);
      } else if (paymentMode.name === "Cash & Bank") {
        const cashId = paymentMode.id.cashId;
        const bankId = paymentMode.id.bankId;

        payment_id = cashId; // You can assign cashId or bankId based on your preference
        totalAmount = JSON.parse(tenderCash); // Assuming tenderCash is the total amount paid
      } else if (paymentMode.name === "Credit") {
        totalAmount = netTotal;
      } else {
        payment_id = paymentMode.id; // For other payment methods
        totalAmount =
          paymentMode.name === "Bank" ||
            paymentMode?.name === "Credit Card" ||
            paymentMode?.name === "Prepaid" ||
            paymentMode?.name === "ValU" ||
            paymentMode?.name === "Vodafone Cash" ||
            paymentMode?.name === "PayU" ||
            paymentMode?.name === "Fawry"
            ? netTotal
            : tenderCash ? JSON.parse(tenderCash) : 0;

        console.log("total Amount ---> 5", totalAmount);
        console.log("netTotal Amount ---> 5", netTotal);
      }

      // let amount_is = paymentMode.name === "Cash & Bank" ? totalAmount : total
      let payment_type;

      if (paymentMode?.name === "Cash") {
        payment_type = "cash";
      } else if (paymentMode?.name === "Bank" || paymentMode?.bank_id) {
        payment_type = "bank";
      } else if (paymentMode?.name === "COD") {
        payment_type = "COD";
        // payment_type = "delivery";
      } else if (paymentMode?.name === "Cash & Bank") {
        payment_type = "cash_bank";
      } else if (paymentMode?.name === "Credit Card") {
        payment_type = "credit_card";
      } else if (paymentMode?.name === "InstaPay") {
        payment_type = "insta_pay";
      } else if (paymentMode?.name === "Credit") {
        payment_type = "Credit";
        // payment_type = "cash";
      } else if (paymentMode?.name === "InstaPay") {
        payment_type = "insta_pay";
      } else if (paymentMode?.name === "ValU") {
        payment_type = "ValU";
      } else if (paymentMode?.name === "Vodafone Cash") {
        payment_type = "Vodafone_Cash";
        // payment_type = "bank";
      } else if (paymentMode?.name === "PayU") {
        payment_type = "PayU";
        // payment_type = "bank";
      } else if (paymentMode?.name === "Fawry") {
        payment_type = "Fawry";
        // payment_type = "bank";
      } else if (paymentMode?.name === "Prepaid") {
        payment_type = "Prepaid";
        // payment_type = "bank";
      } else if (paymentMode?.name === "Delivery") {
        payment_type = "delivery";
      } else {
        payment_type = "";
      }

      // Calculate total amount including delivery fee
      let GrandtotalAmount =
        total +
        (orderFrom?.name === "self_delivery" || paymentMode.name === "COD"
          ? delivery_fee
          : 0);

      // ---------------- PAYMENT HANDLING ----------------
      let NettotalAmount = netTotal; // Simplified since discount applied correctly now

      console.log(localProducts, "localProductslocalProductslocalProductslocalProducts");

      let payloads = {
        lang: i18next.language === "ar" ? "ar_001" : "en_US",
        is_app_order: false,
        device_type: "Web",
        is_credit_order: paymentMode?.name === "Credit",
        data: {
          salesman_id: selectedSalesman?.value,
          delivery_boy_id:selectedDeliveryBoys?.value,

          offer_id: localProducts.find((p) => p.promo_offer_type === "buy_x_get_y") ? false : localProducts.find((p) => p.promo_offer_type !== "buy_x_get_y")?.promotion_id || false,


          pos_session_id: user?.result?.session_id,
          user_id: user?.result?.user_id,
          payment_type: payment_type,
          state: "paid",

          amount_total: netTotal,
          amount_paid: netTotal,
          ...(isETAenabled && {
            total_tax_amount: Number(
              (totalTaxAmount + totalTaxAmountInclusive).toFixed(2),
            ),
          }), // ✅ ADDED
          amount_tax: 0,
          amount_return:
            tenderCash && payment_type === "cash" ? tenderCash - netTotal : 0,

          // ---------------- DISCOUNT FIELDS ----------------
          discount_type: OrderdiscountType == 'value' ? "Amount" : OrderdiscountType == 'percentage' ? 'Amount' : '',
          discount_amount: OrderdiscountAmount,
          discount_per: OrderdiscountPer,

          // total_discount: totalDiscount,
          total_discount: totalDiscount,
          // total_discount: OrderdiscountAmount,

          lines: lines,
          to_invoice: false,
          sequence_number: "",
          to_ship: false,
          is_tipped: false,
          tip_amount: 0,
          partner_id: partner || 0,
          creation_date: formattedDate,
          fiscal_position_id: "",
          pricelist_id: 1,
          delivery_fee: delivery_fee,
          statement_ids: [],
          order_from_id: orderFrom ? orderFrom.id : false,
        },
      };

      // Add statement IDs based on payment method
      if (paymentMode.name === "Cash & Bank") {
        console.log("paymentMode.name === Cash & Bank", paymentMode);
        console.log("totalAmount Cash & Bank", totalAmount);
        console.log("tenderCash Cash & Bank", tenderCash);
        console.log("total Cash & Bank", total);

        payloads.data.statement_ids.push(
          [
            0,
            0,
            {
              name: formattedDate,
              // payment_method_id: paymentMode.id.cashId, // Use cash ID
              payment_method_id:
                paymentMode.id.cashId || paymentMode?.cash_payment_method_id, // Use cash ID
              amount: totalAmount,
              payment_status: "",
              ...(paymentMode?.bank_id && { bank_id: paymentMode?.bank_id }),
              ticket: "",
              card_type: "",
              cardholder_name: "",
              transaction_id: "",
            },
          ],
          [
            0,
            0,
            {
              name: formattedDate,
              payment_method_id:
                paymentMode.id.bankId || paymentMode?.bank_payment_method_id, // Use bank ID
              amount: tenderCash ? netTotal - tenderCash : 0,
              payment_status: "",
              ticket: "",
              card_type: "",
              cardholder_name: "",
              transaction_id: "",
            },
          ],
        );
      } else {
        console.log("else 2222 ", payloads);
        // console.log("paymentMode.name === Cash & Bank", paymentMode);

        // Push cash entry ONLY if cashId exists
        if (paymentMode?.id?.cashId) {
          payloads.data.statement_ids.push([
            0,
            0,
            {
              name: formattedDate,
              payment_method_id: paymentMode.id.cashId || paymentMode?.cash_payment_method_id,
              amount: Number(tenderCash),
              payment_status: "",
              bank_id: '',
              ticket: "",
              card_type: "",
              cardholder_name: "",
              transaction_id: "",
            },
          ]);
        }

        // Always push second entry
        payloads.data.statement_ids.push([
          0,
          0,
          {
            name: formattedDate,
            payment_method_id: paymentMode.id.methodId || paymentMode.id,
            amount:
              (orderFrom?.name === "self_delivery" && paymentMode?.name != "Prepaid" && paymentMode?.name != "Credit") || paymentMode?.name === "COD"
                ? 0
                : paymentMode?.name !== "Cash"
                  ? (tenderCash ? netTotal - tenderCash : netTotal)
                  : tenderCash,
            payment_status: "",
            ...(paymentMode?.bank_id && { bank_id: paymentMode?.bank_id }),
            ticket: "",
            card_type: "",
            cardholder_name: "",
            transaction_id: "",
          },
        ]);
      }

      const response = await axiosInstance.post(
        URLS.CREATE_ORDER_NEW,
        payloads,
      );
      if (response?.data.result.status === "Successfully") {
        const order_id = response?.data?.result?.order_id;

        if (paymentMode?.name === "Credit") {
          const creditPayload = {
            customer_id: partner,
            credit_amount: Number(netTotal),
          };

          try {
            const creditResponse = await axiosInstance.post(
              URLS.ADD_CREDIT,
              creditPayload,
            );

            if (creditResponse?.data.result[0]?.status === "POS Credit Added") {
              const cashOutPayload = {
                session_id: userData?.session_id,
                type: "cash_out",
                // amount: -total + Number(deliveryFee),
                amount: -(Number(total) + Number(deliveryFee)),
                reason: "CREDIT ORDER",
                is_refund_with_new: false,
                is_credit_order: paymentMode?.name === "Credit" ? true : false,
                lang: i18next.language === "ar" ? "ar_001" : "en_US",
              };

              try {
                const cashOutResponse = await axiosInstance.post(
                  URLS.CASH_IN_OUT,
                  cashOutPayload,
                );
                if (cashOutResponse?.data.status !== "Success") {
                  console.error("Cash in/out failed:", cashOutResponse?.data);
                }
              } catch (err) {
                console.error("Error in CASH_IN_OUT API:", err);
              }
            } else if (creditResponse?.data.status !== "Success") {
              console.error("Credit API failed, skipping cash out.");
            }
          } catch (err) {
            console.error("Error in AddPosCredit API:", err);
          }
        }

        navigate(`/OrderCheckout?order_id=${order_id}`);
      } else if (
        response?.data.result.status === "Session not in opened state."
      ) {
        setIsSessionLogout(true);
      } else if (
        response?.data.result.status_code === 400 &&
        response?.data.result.status ===
        "Subscription is Expired...Please Renew."
      ) {
        setIsSubscription(true);
      }
    } catch (err) {
    } finally {
      setLoading(false);
      setIsApiInProgress(false);
    }
  };

  const handleReturnButtonClick = () => {
    const handleClick = () => {
      dispatch(setForRefund(true));
      navigate(`/orders?refundorder`);
    };
    handleClick();
  };

  useEffect(() => {
    const keyMappings = {
      Enter: ["Enter", "إدخال"],
      Escape: ["Escape", "هروب"],
      J: ["J", "ـ"],
      K: ["K", "،"],
      R: ["R", "ٌ"],
    };

    const isKeyMatch = (key, targets) => targets.includes(key);

    const handleGlobalKeyDown = (e) => {
      if (
        e.ctrlKey &&
        isKeyMatch(e.key, keyMappings.Enter) &&
        localProducts.length > 0
      ) {
        e.preventDefault();
        handlePayButtonClick();
        setSelectedIndex(null);
      } else if (isKeyMatch(e.key, keyMappings.Escape)) {
        e.preventDefault();
        if (isAddCustomerModalOpen2 === true) {
          setCompanyCheckout(false);
          setIsAddCustomerModalOpen2(false);
        } else {
          closePaymentModal();
        }
      } else if (e.shiftKey && isKeyMatch(e.key, keyMappings.R)) {
        e.preventDefault();
        handleReturnButtonClick();
      } else if (e.shiftKey && isKeyMatch(e.key, keyMappings.J)) {
        e.preventDefault();
        openCashInModal();
        closeCashOutModal();
      } else if (e.shiftKey && isKeyMatch(e.key, keyMappings.K)) {
        e.preventDefault();
        openCashOutModal();
        closeCashInModal();
      } else if (
        e.shiftKey &&
        isKeyMatch(e.key, keyMappings.Enter)
      ) {
        e.preventDefault();
        if (localProducts.length > 0 && !isProcessingRef.current) {
          e.preventDefault();
          isProcessingRef.current = true;  // ← set synchronously before async work
          getPaymentMethod();
        }

      }
    };

    window.addEventListener("keydown", handleGlobalKeyDown);
    return () => {
      window.removeEventListener("keydown", handleGlobalKeyDown);
    };
  }, [localProducts, selectedCustomer, openCashInModal, openCashOutModal]);

  const totalQuantity = localProducts?.reduce(
    (sum, item) => sum + ((item.uom == 'KG' || item.uom == "كجم") && item.is_selling_gram ? item.quantity / 1000 : item.quantity),
    0,
  );

  

  return (
    <>
      {showBillOfferModal && (
        <FreeOfferModal
          offers={billOfferChoices}
          quantity={totalAmount}
          selectedPromotionId={selectedBillOffer?.promotion_id}
          onSelect={handleBillOfferSelect}
          onClose={() => {
            // If it's a bill offer and nothing has been selected yet, auto-add the first free product
            if (!selectedBillOffer && billOfferChoices?.length > 0) {
              handleBillOfferSelect(billOfferChoices[0]);
            }
            setShowBillOfferModal(false);
          }}
          isBillOffer={true}
        />
      )}
      {isPaymentModalOpen && (
        <PaymentModal
          onClose={closePaymentModal}
          // grandTotal={totalAmount}
          isCompanyCheckout={isCompanyCheckout}
          grandTotal={originalTotal}
          handleCheckout={handleCheckout}
          setTenderCash={setTenderCash}
          creditAmount={creditAmount}
          setCreditAmount={setCreditAmount}
          deliveryCheck={deliveryCheck}
          deliveryFee={deliveryFee}
          setDeliveryFee={setDeliveryFee}
          returnDeliveryFee={returnDeliveryFee}
          setReturnDeliveryFee={setReturnDeliveryFee}
          showReturnDelivery={showReturnDelivery}
          constReturnDeliveryFee={constReturnDeliveryFee}
          discountType={discountType}
          setDiscountType={setDiscountType}
          discountValue={discountValue}
          setDiscountValue={setDiscountValue}
          originalTotal={originalTotal}
          totalBillAmount={totalBillAmount}
          totalCostPrice={totalCostPrice}
          nonReturnTotal={nonReturnTotal}
          billDiscountAmount={billDiscount}
        />
      )}
      {(isAddCustomerModalOpen || isAddCustomerModalOpen2) && (
        <AddCustomer_Modal
          onClose={() => {
            setIsAddCustomerModalOpen(false);
            setIsAddCustomerModalOpen2(false);
            if (!isPaymentModalOpen) {
              dispatch(setClosePaymentModal());
            }
          }}
          confirm={(val) =>
            isAddCustomerModalOpen2
              ? confirmAddCustomerModal(val)
              : conformAddCustomerModal(val)
          }
          showSkipButton={isPaymentModalOpen ? false : true}
          isAddressMandatory={isPaymentModalOpen}
        />
      )}
      {/* {isAddCustomerModalOpen2 && (
        <AddCustomer_Modal
          onClose={() => {
            setCompanyCheckout(false);
            setIsAddCustomerModalOpen2(false);
          }}
          confirm={confirmAddCustomerModal}
          showSkipButton={false}
        />
      )} */}
      {isCashInModalOpen && (
        <CashIn_Modal
          onClose={closeCashInModal} // Pass the function to close the modal
          title="Cash In"
          handleSubmit={() => {
            // getData();
            // Handle the submission of cash-in
            closeCashInModal();
            // Add any additional logic for handling the cash-in process
          }}
        />
      )}

      {isCashOutModalOpen && (
        <CashIn_Modal
          onClose={closeCashOutModal} // Pass the function to close the modal
          title="Cash Out"
          handleSubmit={() => {
            // getData();
            // Handle the submission of cash-out
            closeCashOutModal();
          }}
        // cashDifference={dashboardData?.cash_difference}
        />
      )}
      {isSessionLogout && <SessionLogout />}
      {isSubscription && (
        <SubscriptionExpired onClose={closeSubscriptionModal} />
      )}
      {loading && <LoadingSpinner />}
      <div
        style={{
          position: "fixed",
          bottom: 0,
          backgroundColor: "white",
          borderRadius: "0.375rem",
          border: "1px solid #d6d3d1", // border-stone-300
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)", // shadow-sm
          padding: "0.5rem 1rem", // py-2 px-4
          width: "100%",
          zIndex: 10,
        }}
      >
        <div className="flex items-center text-xl font-semibold justify-between text-white w-full">
          <div className="flex  flex-row ">
            <div className="flex flex-col items-start w-[370px]">
              <div className="text-black text-sm font-normal">
                {t("Items :")} {itemCount}
              </div>
              <div className="text-xl text-gray-700 justify-center items-center">
                {t("Total :")}{" "}
                <span className="text-2xl ml-1 text-black justify-center items-center">
                  {i18n.language === "ar" && totalAmount < 0
                    ? `${-totalAmount.toFixed(2)}-`
                    : totalAmount.toFixed(2)}{" "}
                  EGP
                </span>
              </div>
            </div>
            <div className="  ">
              <button
                onClick={handlePayButtonClick}
                className={`flex flex-col justify-center items-center px-5 h-16 whitespace-nowrap rounded-xl shadow-sm bg-[#6BB12C] text-white max-md:px-5 cursor-pointer ${deviceType === "tablet" ? "w-[100px]" : "w-[190px]"
                  } ${totalQuantity <= 0 ? "opacity-60 cursor-not-allowed" : ""}`}
                disabled={totalQuantity <= 0}
              >
                <div>{t("Pay")}</div>
              </button>
            </div>
            <div className="mx-4">
              <button
                onClick={handleCompanyPayButtonClick}
                className={`flex flex-col justify-center items-center py-5 whitespace-nowrap rounded-xl px-5 h-16 shadow-sm bg-[#1b4597] text-white cursor-pointer ${deviceType === "tablet" ? "w-[100px]" : "w-[190px]"
                  } ${totalQuantity <= 0 || orderFromOptions?.length < 1 || returnProducts?.length > 0
                    ? "opacity-60 cursor-not-allowed"
                    : ""
                  }`}
                disabled={totalQuantity <= 0 || orderFromOptions?.length < 1 || returnProducts?.length > 0}
              >
                <div>{t("Delivery")}</div>
              </button>
            </div>
          </div>

          <div className="flex flex-row justify-end ">
            <div style={{ marginRight: 10 }}>
              <QuickSettleButton
                onClick={getPaymentMethod}
                totalQuantity={totalQuantity}
              />
            </div>

            <div style={{ marginRight: 10 }}>
              <ReturnButton />
            </div>

            <div style={{ marginRight: 10 }}>
              <CashInButton openCashInModal={openCashInModal} />
            </div>

            <div style={{ marginRight: 10 }}>
              <CashOutButton openCashOutModal={openCashOutModal} />
            </div>
          </div>

          {/* </div> */}
        </div>
      </div>
    </>
  );
};

export default SessionFooter;
